import { type PayloadAction, createSlice } from "@reduxjs/toolkit"

import { logout } from "../containers/LoginPage/redux/auth.thunks"
import { unknownError } from "../utils/handlers/handle-error"

export interface ErrorsState {
  data: unknown | null
}

type ErrorsRootState = {
  errors: ErrorsState
}

const initialState: ErrorsState = {
  data: null
}

const errorsSlice = createSlice({
  name: "errors",
  initialState,
  reducers: {
    errorSave: (state, action: PayloadAction<unknown>) => {
      state.data = action.payload || unknownError
    },
    errorReset: () => initialState
  },
  extraReducers: (builder) => {
    builder.addCase(logout.fulfilled, () => {
      console.log("errors logout")
      return initialState
    })
  }
})

export const { errorSave, errorReset } = errorsSlice.actions

export const ErrorsSelectors = {
  getState: (state: ErrorsRootState) => state.errors,
  getData: (state: ErrorsRootState) => state.errors.data
}

export default errorsSlice
